import qrcode from 'qrcode-generator';


const B_TO_E = { B01: 'E31', B02: 'E32', B03: 'E33', B04: 'E34', B14: 'E44', B15: 'E45' };
const E_TO_B = Object.fromEntries(Object.entries(B_TO_E).map(([b, e]) => [e, b]));

export const isElectronicMode = (config) => config?.tipo_facturacion === 'electronica';

// Convierte un tipo NCF al equivalente del modo activo (B <-> E)
export const adaptNcf = (code, electronic) =>
  electronic ? (B_TO_E[code] || code) : (E_TO_B[code] || code);

export const isCreditoFiscal = (code) => code === 'B01' || code === 'E31';

// Bloque HTML con QR, código de seguridad y fecha de firma (solo modo electrónico)
export const ecfBlock = (invoice, config) => {
  if (!isElectronicMode(config) || !String(invoice?.ncf || '').startsWith('E')) return '';
  if (!invoice.ecf_qr) {
    return '<div style="text-align:center;font-size:10px;margin:2mm 0;">e-CF pendiente de envío a la DGII</div>';
  }
  const qr = qrcode(0, 'M');
  qr.addData(invoice.ecf_qr);
  qr.make();
  return `
    <div style="text-align:center;margin:3mm 0;" class="ecf-qr-block">
      <div style="display:inline-block;width:32mm;height:32mm;">${qr.createSvgTag({ cellSize: 3, margin: 0, scalable: true })}</div>
      <div style="font-size:10px;margin-top:1mm;"><b>Código de Seguridad:</b> ${invoice.ecf_codigo_seguridad || '-'}</div>
      <div style="font-size:10px;"><b>Fecha de Firma:</b> ${invoice.ecf_fecha_firma || '-'}</div>
    </div>`;
};

export const ncfPad = (tipo) => (String(tipo || '').startsWith('E') ? 10 : 8);

export const NCF_TITLES = {
  B01: 'FACTURA DE CREDITO FISCAL',
  B02: 'FACTURA DE CONSUMO',
  B03: 'NOTA DE DEBITO',
  B04: 'NOTA DE CREDITO',
  B14: 'FACTURA REGIMEN ESPECIAL',
  B15: 'FACTURA GUBERNAMENTAL',
  E31: 'FACTURA DE CREDITO FISCAL ELECTRONICA',
  E32: 'FACTURA DE CONSUMO ELECTRONICA',
  E33: 'NOTA DE DEBITO ELECTRONICA',
  E34: 'NOTA DE CREDITO ELECTRONICA',
  E44: 'FACTURA REGIMEN ESPECIAL ELECTRONICA',
  E45: 'FACTURA GUBERNAMENTAL ELECTRONICA',
};

export const CLIENT_NCF_OPTIONS = {
  B: [
    { code: 'B01', description: 'Crédito Fiscal' },
    { code: 'B02', description: 'Consumidor Final' },
    { code: 'B14', description: 'Régimen Especial' },
    { code: 'B15', description: 'Gubernamental' },
  ],
  E: [
    { code: 'E31', description: 'e-Crédito Fiscal' },
    { code: 'E32', description: 'e-Consumidor Final' },
    { code: 'E44', description: 'e-Régimen Especial' },
    { code: 'E45', description: 'e-Gubernamental' },
  ],
};
